"use strict";

exports.__esModule = true;
exports.default = void 0;

var remToPx = function remToPx(rem) {
  return parseFloat(rem) * parseFloat(getComputedStyle(document.documentElement).fontSize);
};

var _default = remToPx;
exports.default = _default;